export const NOTIFICATION_ANIMATION_TYPES = {
  FADE: 'fade',
  LEFT: 'left',
  RIGHT: 'right',
}
